import edit from './edit'
import send from './send'
import guest from './guest'
import chipIn from './chip_in'
import CampaignPage from 'components/pages/campaign'
import CampaignNotFound from 'components/pages/campaign_not_found'
import CountryBlocked from 'components/common/country_blocked'
import CrowdFundingDetailsPage from 'components/pages/crowdfunding/crowdfunding_details'
import { getCampaignSelector } from 'redux/selectors/campaign'
import createRoute from './create'
import createCrowdfundingRoute from './create_crowdfunding'
import hubRoute from './hub'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import fetchClient from 'lib/fetch_client'
import routes from 'server_routes'
import {
  buildTransaction,
  createDNWTransactionSuccess,
  createDNWTransactionFailure,
  setIsLoading,
} from 'redux/modules/dnw_transaction'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export default (store, history, path) => ({
  indexRoute: hubRoute(store, history),
  path,
  childRoutes: [
    createRoute(store),
    createCrowdfundingRoute(store),
    {
      path: ':campaignId',
      onEnter(nextState) {
        const queryToken = nextState.location.query.token
        const prevTxnCount = nextState.location.query.txn_count
          ? Number(nextState.location.query.txn_count)
          : 0
        const campaign = getCampaignSelector(store.getState(), {
          campaignId: nextState.params.campaignId,
        })
        const txnCount = campaign ? campaign.txn_count : undefined
        const shouldRequestTnxDetails =
          prevTxnCount === txnCount && Boolean(queryToken)

        if (shouldRequestTnxDetails) {
          store.dispatch(setIsLoading(true))
          return fetchClient()
            .request(
              routes.campaign.api.get_payments_token_transaction({
                id: queryToken,
              }),
              {
                method: 'GET',
              }
            )
            .then(({ anonymous, sender, transaction_details }) => {
              const campaignId = nextState.params.campaignId
              store.dispatch(
                createDNWTransactionSuccess(
                  buildTransaction({
                    anonymous: anonymous,
                    campaign_id: campaignId,
                    date: new Date().toISOString(),
                    transaction_details: {
                      ...transaction_details,
                    },
                  }),
                  sender
                )
              )
            })
            .catch(error => {
              store.dispatch(createDNWTransactionFailure(error))
              return error
            })
            .finally(() => {
              history.replace(nextState.location.pathname)
            })
        } else if (nextState.location.query.txn_count) {
          // when a user cancels DNW flow the return url will have query param txn_count
          // we remove it here
          history.replace(nextState.location.pathname)
        }
      },
      getComponent(nextState, callback) {
        if (!store.getState().user_config) {
          return callback(null, CountryBlocked)
        }
        let campaign = getCampaignSelector(store.getState(), {
          campaignId: nextState.params.campaignId,
        })
        if (!campaign) {
          return callback(null, CampaignNotFound)
        }

        // return crowdfunding detail component
        if (campaign.campaign_type === CROWD_FUNDING) {
          return callback(null, CrowdFundingDetailsPage)
        }
        return callback(null, CampaignPage)
      },
      childRoutes: [
        edit(store, history),
        send(store, history),
        guest(store, history),
        chipIn(store, history),
      ],
    },
  ],
})
